export const headerItems = [
  {
    id: 1,
    title: 'in-play',
    path: '/inplay',
    imgUrl: '/images/header/inplay-icon.png',
  },
  // {
  //   id: 2,
  //   title: 'wwc 2026',
  //   path: '/sports/cricket/market-details/182',
  //   imgUrl: '/images/header/winner-icon.png',
  // },
  {
    id: 3,
    title: 'cricket',
    path: '/sports/cricket',
    imgUrl: '/images/header/cricket-icon.png',
  },
  {
    id: 4,
    title: 'soccer',
    path: '/sports/football',
    imgUrl: '/images/header/soccer-icon.png',
  },
  {
    id: 5,
    title: 'tennis',
    path: '/sports/tennis',
    imgUrl: '/images/header/tennis-icon.png',
  },
  {
    id: 6,
    title: 'horse',
    path: '/racing/HorseRacing',
    imgUrl: '/images/header/horse-icon.png',
  },
  {
    id: 7,
    title: 'greyhound',
    path: '/racing/Greyhound',
    imgUrl: '/images/header/greyhound-icon.png',
  },
  {
    id: 8,
    title: 'fantasy 11',
    path: '/FANTASY11',
    imgUrl: '/images/header/fantasy11-icon.png',
  },
  {
    id: 9,
    title: 'indian poker',
    path: '/INDIANPOKER',
    imgUrl: '/images/header/indianpoker-icon.png',
  },
  {
    id: 10,
    title: 'aura casino',
    path: '/AURACASINO',
    imgUrl: '/images/header/auracasino-icon.png',
  },
  {
    id: 11,
    title: 'aviator',
    path: '/AVIATOR',
    imgUrl: '/images/header/aviator-icon.png',
  },
  {
    id: 12,
    title: 'chicken road',
    path: '/CHICKENROAD',
    imgUrl: '/images/header/chickenroll-icon.png',
  },
  {
    id: 13,
    title: 'live casino',
    path: '/LIVECASINO',
    imgUrl: '/images/header/livecasino-icon.png',
  },
  {
    id: 14,
    title: 'int.casino',
    path: '/INTCASINO',
    imgUrl: '/images/header/intcasino-icon.png',
  },
  {
    id: 15,
    title: 'slot',
    path: '/SLOT',
    imgUrl: '/images/header/slot-icon.png',
  },
];

export const mobileHeaderItems = [
  // {
  //   id: 1,
  //   title: 'wwc 2026',
  //   path: '/sports/cricket/market-details/182',
  //   imgUrl: '/images/header/winner-icon.png',
  // },
  {
    id: 1,
    title: 'in-play',
    path: '/inplay',
    imgUrl: '/images/header/inplay-icon.png',
  },
  {
    id: 2,
    title: 'cricket',
    path: '/sports/cricket',
    imgUrl: '/images/header/cricket-icon.png',
  },
  {
    id: 3,
    title: 'soccer',
    path: '/sports/football',
    imgUrl: '/images/header/soccer-icon.png',
  },
  {
    id: 4,
    title: 'tennis',
    path: '/sports/tennis',
    imgUrl: '/images/header/tennis-icon.png',
  },
  {
    id: 5,
    title: 'horse',
    path: '/racing/HorseRacing',
    imgUrl: '/images/header/horse-icon.png',
  },
  {
    id: 6,
    title: 'greyhound',
    path: '/racing/Greyhound',
    imgUrl: '/images/header/greyhound-icon.png',
  },
  {
    id: 7,
    title: 'fantasy 11',
    path: '/FANTASY11',
    imgUrl: '/images/header/fantasy11-icon.png',
  },
  {
    id: 8,
    title: 'indian poker',
    path: '/INDIANPOKER',
    imgUrl: '/images/header/indianpoker-icon.png',
  },
  {
    id: 9,
    title: 'aura casino',
    path: '/AURACASINO',
    imgUrl: '/images/header/auracasino-icon.png',
  },
  {
    id: 10,
    title: 'aviator',
    path: '/AVIATOR',
    imgUrl: '/images/header/aviator-icon.png',
  },
  {
    id: 11,
    title: 'chicken road',
    path: '/CHICKENROAD',
    imgUrl: '/images/header/chickenroll-icon.png',
  },
  {
    id: 12,
    title: 'live casino',
    path: '/LIVECASINO',
    imgUrl: '/images/header/livecasino-icon.png',
  },
  {
    id: 13,
    title: 'int.casino',
    path: '/INTCASINO',
    imgUrl: '/images/header/intcasino-icon.png',
  },
  {
    id: 14,
    title: 'slot',
    path: '/SLOT',
    imgUrl: '/images/header/slot-icon.png',
  },
];

export const mainBanners = [
  {
    id: 1,
    img: '/images/main-banner/main-banner0.jpg',
  },
  {
    id: 2,
    img: '/images/main-banner/main-banner2.webp',
  },
  {
    id: 3,
    img: '/images/main-banner/main-banner3.webp',
  },
  {
    id: 4,
    img: '/images/main-banner/main-banner4.webp',
  },
];

export const mainBannersMobile = [
  {
    id: 1,
    img: '/images/main-banner/main-banner-mobile0.jpg',
  },
  {
    id: 2,
    img: '/images/main-banner/main-banner-mobile1.webp',
  },
  {
    id: 3,
    img: '/images/main-banner/main-banner-mobile2.webp',
  },
  {
    id: 4,
    img: '/images/main-banner/main-banner-mobile3.webp',
  },
  {
    id: 5,
    img: '/images/main-banner/main-banner-mobile4.webp',
  },
];
export const mainBannersLogin = [
  {
    id: 1,
    img: '/images/afterloginhome/desktop_banner_2.jpeg',
  },
  {
    id: 2,
    img: '/images/afterloginhome/desktop_banner_3.jpeg',
  },
  {
    id: 3,
    img: '/images/afterloginhome/desktop_banner_4.jpeg',
  },
  {
    id: 4,
    img: '/images/afterloginhome/desktop_banner_6.jpeg',
  },
  {
    id: 5,
    img: '/images/afterloginhome/desktop_banner_16.jpg',
  },
  {
    id: 6,
    img: '/images/afterloginhome/desktop_banner_17.jpg',
  },
  {
    id: 7,
    img: '/images/afterloginhome/desktop_banner_18.jpg',
  },
  {
    id: 8,
    img: '/images/afterloginhome/desktop_banner_19.jpg',
  },
];
// export const privateMenu: MenuItem[] = [
//   { label: 'My Wallet', path: '/wallet', icon: 'myWallet', order: 4 },
//   // { label: 'My Transaction', path: '/transactions', icon: 'myTransaction' },
//   { label: 'Bet History', path: '/bet-history', icon: 'betHistory', order: 5 },
//   { label: 'Casino Bet History', path: '/casino-bet-history', icon: 'betHistory', order: 6 },
//   { label: 'Betting Profit & Loss', path: '/profit-loss', icon: 'bettingProfitLoss', order: 7 },
//   { label: 'Turnover History', path: '/turnover-history', icon: 'turnoverHistory', order: 8 },
//   { label: 'Account Statement', path: '/account-statement', icon: 'accountStatement', order: 9 },
//   // { label: 'Commission Report', path: '/commission-report', icon: 'commissionReport' },
//   { label: 'Bonus', path: '/bonus-statement', icon: 'bonusStatement', order: 10 },
//   { label: 'Referral', path: '/referral', icon: 'referral', order: 11 },
//   { label: 'Stake Settings', path: '/stake-settings', icon: 'stakeSettings', order: 12 },
//   { label: 'My Profile', path: '/my-profile', icon: 'myProfile', order: 13 },
//   { label: 'Change Password', path: '/change-password', icon: 'lock', order: 14 },
// ];
// whatsapp/telegram come from useGetContactSupportQuery; these are the rest.
export const socialLinks = [
  { platform: 'facebook', url: '#' },
  { platform: 'insta', url: '#' },
  { platform: 'twitter', url: '#' },
  { platform: 'youtube', url: '#' },
];

export const buildWhatsappLink = (value?: string | null) => {
  if (!value) return '';
  return value.startsWith('http') ? value : `https://wa.me/${value.replace(/\D/g, '')}`;
};

export const buildTelegramLink = (value?: string | null) => {
  if (!value) return '';
  return value.startsWith('http') ? value : `https://t.me/${value.replace(/^@/, '')}`;
};

export const profileDrawerItems = [
  {
    id: 14,
    title: 'Coin Reward',
    path: '/coins',
    imgUrl: '/images/profile/coin-reward.svg',
  },
  {
    id: 1,
    title: 'Account Statement',
    path: '/account-statement',
    imgUrl: '/images/profile/account-statement.svg',
  },
  {
    id: 2,
    title: 'Profit Loss Report',
    path: '/profit-loss',
    imgUrl: '/images/profile/profit-loss-report.svg',
  },
  {
    id: 3,
    title: 'Bet History',
    path: '/bet-history',
    imgUrl: '/images/profile/bet-history.svg',
  },
  {
    id: 4,
    title: 'Unsettled Bet',
    path: '/unsettled-bet',
    imgUrl: '/images/profile/unsettled-bet.svg',
  },
  {
    id: 5,
    title: 'Casino Bet History',
    path: '/casino-bet-history',
    imgUrl: '/images/profile/bet-history.svg',
  },
  {
    id: 6,
    title: 'Set Stake',
    path: '/stake-settings',
    imgUrl: '/images/profile/set-stake.svg',
  },
  {
    id: 7,
    title: 'Rules',
    path: '/rules',
    imgUrl: '/images/profile/rules.svg',
  },
  {
    id: 8,
    title: 'Change Password',
    path: '/change-password',
    imgUrl: '/images/profile/change-password.svg',
  },
  {
    id: 9,
    title: 'Results',
    path: '/results',
    imgUrl: '/images/profile/results.svg',
  },
  {
    id: 10,
    title: 'Export Report History',
    path: '/export-report-history',
    imgUrl: '/images/profile/account-statement.svg',
  },
  {
    id: 11,
    title: 'Bonus History',
    path: '/bonus-statement',
    imgUrl: '/images/profile/bonus-statement.svg',
  },
  {
    id: 12,
    title: 'Commission',
    path: '/commission',
    imgUrl: '/images/profile/profit-loss-report.svg',
  },
  {
    id: 13,
    title: 'Referral',
    path: '/referral',
    imgUrl: '/images/profile/referral.svg',
  },
];
